var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-container"},[_c('JsonEditorVue',{staticClass:"editor-input",attrs:{"mode":"text","onRenderMenu":_vm.onRenderMenu},model:{value:(_vm.eventProxy),callback:function ($$v) {_vm.eventProxy=$$v},expression:"eventProxy"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }